import { en } from './en';
import { ru } from './ru';
import { cs } from './cs';
import type { Locale } from '../../contexts/LocaleContext';

export type UITranslations = typeof en;

export const translations: Record<Locale, UITranslations> = {
    en,
    ru,
    cs,
};

// Hook для использования переводов (будет использоваться через контекст)
export function getTranslations(locale: Locale): UITranslations {
    return translations[locale] || translations.en;
}

